import { useParams } from 'react-router-dom';
import { useCondoContext } from '@/features/auth/use-condo-context';
import { ResultadosAsamblea } from '@/features/asambleas/resultados';

export function AsambleaResultadosRoute() {
  const { asambleaId } = useParams<{ asambleaId: string }>();
  const { condoId } = useCondoContext();

  if (!asambleaId) return null;

  return <ResultadosAsamblea condoId={condoId} asambleaId={asambleaId} />;
}
